export default {
  license_agreement: require('./license_agreement.txt').default,
  license_agreement__product_cibr: require('./license_agreement__product_cibr.txt').default
};
